import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import './Dashboard.css';
import dashImg from '../../images/dashboard.svg';
import profImg from '../../images/profile.svg';
import addInfImg from '../../images/additional-info.svg';
import evidImg from '../../images/evidence.svg';
import updtImg from '../../images/updates.svg';
import notifyImg from '../../images/notification.svg';
import resourceImg from '../../images/resources.svg';
import faqImg from '../../images/faq-icon.svg';
import dashHover from '../../images/dashboard-hover.svg';
import profHover from '../../images/profile-hover.svg';
import addInHover from '../../images/additional-info-hover.svg';
import evidHover from '../../images/evidence-hover.svg';
import updtHover from '../../images/updates-hover.svg';
import notifyHover from '../../images/notification-hover.svg';
import resourceHover from '../../images/resources-hover.svg';
import faqHover from '../../images/faq-icon-hover.svg';
import contact from '../../images/conwhite.svg';
import contactgold from '../../images/congold.svg';
import settings from '../../images/settings3.svg';
import settingsorange from '../../images/settingsorange2.svg';
import overviewsorange from '../../images/overvieworange.svg';
import overview from '../../images/overview.svg';
import subsorange from '../../images/submissionorange.svg';
import sub from '../../images/submissionwhite.svg';




const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    sessionStorage.removeItem('authToken');
    navigate('/');
    window.location.reload();
  };

  // Function to check active route
  const isActive = (path) => {
    return location.pathname === path;
  };

  return (
    <div className="sidebar">
      <h4>Menu</h4>
      <nav className="dash-side-bar-menus">
        <ul className="dash-all-list">
          <li className={isActive('/dashboard') ? 'active' : ''}>
            <Link to="/dashboard">
              <span className="sid-icon">🏠</span> 
              Dashboard
            </Link>
          </li>
          
          <li className={isActive('/users') ? 'active' : ''}>
            <Link to="/users">
              <span className="sid-icon">👤</span> 
              Profile
            </Link>
          </li>
          
          <li className={isActive('/additionalinfo') ? 'active' : ''}>
            <Link to="/additionalinfo">
              <span className="sid-icon">🧾</span> 
              Additional Info
            </Link>
          </li>
          
          <li className={isActive('/evidence') ? 'active' : ''}>
            <Link to="/evidence">
              <span className="sid-icon">📎</span> 
              Evidence
            </Link>
          </li>
          
          <li className={isActive('/caseUpdate') ? 'active' : ''}>
            <Link to="/caseUpdate">
              <span className="sid-icon">📰</span> 
              Updates
            </Link>
          </li>
          
          <li className={isActive('/notifications') ? 'active' : ''}>
            <Link to="/notifications">
              <span className="sid-icon">🔔</span> 
              Notification
            </Link>
          </li>

          <li><h4>Case Info</h4></li>

          <li className={isActive('/caseOverview') ? 'active' : ''}>
            <Link to="/caseOverview">
              <span className="sid-icon">📌</span> 
              Overview
            </Link>
          </li>

          <li className={isActive('/submission') ? 'active' : ''}>
            <Link to="/submission">
              <span className="sid-icon">📤</span> 
              Submissions
            </Link>
          </li>
          
          <li className={isActive('/resources') ? 'active' : ''}>
            <Link to="/resources">
              <span className="sid-icon">📚</span> 
              Resources
            </Link>
          </li>
          
          <li className={isActive('/faqwrapp') ? 'active' : ''}>
            <Link to="/faqwrapp">
              <span className="sid-icon">❓</span> 
              FAQs
            </Link>
          </li>

          <li><h4>Legal</h4></li>

          <li className={isActive('/privacy') ? 'active' : ''}>
            <Link to="/privacy">
              <span className="sid-icon">📜</span> 
              Privacy Policy
            </Link>
          </li>

          <li className={isActive('/terms') ? 'active' : ''}>
            <Link to="/terms">
              <span className="sid-icon">⚖️</span> 
              Terms of Use
            </Link>
          </li>

          <li className={isActive('/contact') ? 'active' : ''}>
            <Link to="/contact">
              <span className="sid-icon">✉️</span> 
              Contact Us
            </Link>
          </li>

          <li className={isActive('/settings') ? 'active' : ''}>
            <Link to="/settings">
              <span className="sid-icon">⚙️</span> 
            Settings
            </Link>
          </li>

        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
